import React from "react";
import { StyledLink } from "./Link.styles";

export default (props) => {
  return <StyledLink {...props}>{props.children}</StyledLink>;
};
